<template>
    <div class="customer-profile">
        <div class="content-area">
            <base-header
                :menu-listing="getMenuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {}, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            menuListing: [
                {
                    anchorLink: '/screening-data/delta-list',
                    menuLabel: 'Screening Data',
                    name: 'upload-delta-list',
                    permission: ['upload-delta-list'],
                    accountTypes: ['standard', 'premium', 'lite'],
                },
            ],
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters(['dataSegmentId', 'user']),
        getMenuListing() {
            return this.menuListing.filter((item) =>
                item.accountTypes.includes(this.user.accountType)
            )
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    mounted() {}, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
